import {LimitAndOffset} from "@/components/table/subComponents/Paginator/Paginator.tsx";
import {useAutoThrowSuspenseQuery} from "@/lib/hooks/useAutoThrowSuspenseQuery";
import {GQL_AUDIT_LOGS_QUERY} from "@/lib/queries/auditlogs.ts";
import {AuditLog, AuditLogListResult} from "@/lib/types/auditlogs.ts";
import {AuditLogsTable} from "@/pages/auditlog/list/components/AuditLogsTable.tsx";
import {EmptyAuditLogList} from "@/pages/auditlog/list/components/EmptyAuditLogList.tsx";

interface AuditLogListProp {
  limitAndOffset: LimitAndOffset;
  setLimitAndOffset: (limitAndOffset: LimitAndOffset) => void;
  search: string;
  objectTypeFilter: string | null;
}

export const AuditLogList = ({limitAndOffset, setLimitAndOffset, search, objectTypeFilter}: AuditLogListProp) => {
  const {limit, offset} = limitAndOffset;
  const {data} = useAutoThrowSuspenseQuery<AuditLogListResult>(GQL_AUDIT_LOGS_QUERY, {
    variables: {
      limit: limit,
      offset: offset,
      search: search ? search : undefined,
      object_type: objectTypeFilter ? objectTypeFilter : undefined,
    },
  });

  const auditLogs: AuditLog[] = data?.auditLogs.items || [];
  const auditLogsTotal = data?.auditLogs.total || 0;

  return data !== undefined && auditLogsTotal < 1 ? (
    <EmptyAuditLogList />
  ) : (
    <AuditLogsTable
      items={auditLogs}
      pagination={limitAndOffset}
      updatePagination={setLimitAndOffset}
      totalRows={auditLogsTotal}
    />
  );
};
